<script setup>
import AdminHeader from "@/components/Admin/header.vue";
import AdminSidebar from "@/components/Admin/sidebar.vue";
import { ref, onMounted } from 'vue';
import HeadBlock from "@/components/Admin/head-block.vue";
import UploadImage from "@/components/Admin/upload-image.vue";
import {useStore} from "vuex";
import { useCommonComposable } from '@/composables/commonComposable.js';

import axios from "axios";
const baseUrl = process.env.VUE_APP_API_URL + "";

const store = useStore();

const { categories, getCategories } = useCommonComposable();

let mainCategory = ref([]);
let actualImages = ref([]); // картинка, которая была изначально, если она есть
const images = ref([]); // переменная для картинок, которые добавляем

const categoryOldName = ref('')
const headerValue = ref('');
const textValue = ref('');
const urlValue = ref('');
const tickerValue = ref({
    key: '',
    value: '',
});

const headerValueCategory = ref('');
const textValueCategory = ref('');
const urlValueCategory = ref('');

const addImage = (img) => {
    images.value = img;
}

const changeMainCategory = async () => {
    let params = {
        categoryName: headerValue.value,
        description: textValue.value,
        categoryUrl: urlValue.value,
        categoryOldName: categoryOldName.value,
    }
    const config = { headers: { 'Cache-Control': 'no-cache' }, withCredentials: true };

    const res = await axios.post(baseUrl + "/categories/updateCategory", params, config);

    await store.dispatch("category/fetchMainCategory");
    mainCategory.value = store.state.category.mainCategory;

    if (images.value.length > 0) {
        params = {
            ext: images.value[0].src.split(',')[0],
            imageBase64: images.value[0].src.split(',')[1],
            categoryName: headerValue.value,
            index: 1,
            typeName: 'Заглавная'
        }
        const config = { headers: { 'Cache-Control': 'no-cache' }, withCredentials: true };
        if (actualImages.value.length < 1) {
            await axios.post(baseUrl + "/images/addImage", params, config)
        } else {
            params.filenameDeleted = actualImages.value[0]['Ссылка'].split('/')[1] // имя старой картинки
            await axios.post(baseUrl + "/images/updateCategoryImage", params, config)
        }
    }
}

const addCategory = async () => {
    let params = {
        categoryName: headerValueCategory.value,
        categoryUrl: urlValueCategory.value,
        description: textValueCategory.value,
    }
    const config = { headers: { 'Cache-Control': 'no-cache' }, withCredentials: true };

    await axios.post(baseUrl + '/categories/addCategory', params, config)

    await getCategories()
}

const updateCategory = async (category) => {
    if (!category["category_new_name"]) category["category_new_name"] = category["category_name"]
    let params = {
        categoryName: category["category_new_name"],
        categoryUrl: category["category_url"],
        description: category["description"],
        categoryOldName: category["category_name"],
    }
    const config = { headers: { 'Cache-Control': 'no-cache' }, withCredentials: true };

    await axios.post(baseUrl + '/categories/updateCategory', params, config)

    await getCategories()
}

const addCategoryItem = async (category) => {
    const categoryName = category["category_name"]
    const productCode = category.newItem
    const config = { headers: { 'Cache-Control': 'no-cache' }, withCredentials: true };

    await axios.post(baseUrl + '/categories/addCategoryItem', {
        categoryName: categoryName,
        productCode: productCode,
    }, config)

    await getCategories()
}

const removeCategoryItem = async (categoryName, code) => {
    const config = { headers: { 'Cache-Control': 'no-cache' }, withCredentials: true };
    await axios.post(baseUrl + '/categories/deleteCategoryItem', {
        categoryName: categoryName,
        productCode: code,
    }, config)

    await getCategories()
}

const saveTickerText = async () => {
    await store.dispatch('category/updateSiteSettings', {
        key: 'ticker_text',
        value: tickerValue.value,
    });
}

onMounted(async () => {
    await store.dispatch("category/fetchMainCategory");
    mainCategory.value = store.state.category.mainCategory;

    await store.dispatch("category/fetchSiteSettings");
    tickerValue.value = store.state.category.settings.find(item => item.key === 'ticker_text').value;

    await store.dispatch("fetchImages", {categoryName: mainCategory.value[0]['category_name']})
    actualImages.value = store.state.images

    headerValue.value = mainCategory.value[0]['category_name'] || ''
    textValue.value = mainCategory.value[0]['description'] || ''
    urlValue.value = mainCategory.value[0]['category_url'] || ''
    categoryOldName.value = mainCategory.value[0]['category_name'] || ''

    await getCategories()
})

</script>

<template>
    <admin-header></admin-header>
    <div class="page not-padding">
        <admin-sidebar :active-route='$route.name'></admin-sidebar>
        <div class="admin-page admin-container-padding">
            <div class="head-row">
                <head-block :headerText="'Главная страница'"
                            :is-add-new="false"
                            :addNewText="''"
                >
                </head-block>
            </div>
            <div class="row card ticker-text__container">
                <div class="header-row">
                    <h4>Текст бегущей строки</h4>
                </div>
                <div class="ticker-text__content">
                    <input name="ticker" id="ticker" placeholder="Введите текст" v-model="tickerValue">
                    <div class="btn default" @click="saveTickerText">
                        <span>Сохранить</span>
                    </div>
                </div>
            </div>
            <div class="row card" id="main-category">
                <div class="header-row">
                <h4>Настройки баннера</h4>
                </div>
                <div class="card-content">
                    <upload-image :defaultImages=[] :images="images ? images : actualImages" @update:images="addImage" :isOnlySingle="true"></upload-image>

                    <div class="text-content">
                        <input name="header-text" id="header-text" placeholder="Заголовок" v-model="headerValue">
                        <input name="label" id="label" placeholder="Подпись" v-model="textValue">
                        <input name="url" id="url" placeholder="Ссылка" v-model="urlValue">
                        <div class="btn default" @click="changeMainCategory">
                            <span>Сохранить</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row card">
                <div class="header-row">
                    <h4>Категории</h4>
                    <span v-if="categories.length === 0">(нет категорий)</span>
                </div>
                <div class="categories-block">
                    <div v-for="cat of categories" class="category-card">
                        <p class="card-head">{{ cat['category_name'] }}</p>
                        <input name="header-text" id="header-text" placeholder="Заголовок" v-model="cat['category_new_name']">
                        <input name="label" id="label" placeholder="Подпись" v-model="cat['description']">
                        <input name="url" id="url" placeholder="Ссылка" v-model="cat['category_url']">
                        <div class="hr"></div>
                        <div class="category-items-block">
                            <div class="category-items">
                                <div class="category-item-elem " v-if="cat.items.length > 0" v-for="item of cat.items">
                                    <span>{{ item.code }}</span>
                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" @click="removeCategoryItem(cat['category_name'], item.code)">
                                        <path d="M10.2423 11.6549L5.99963 7.41225L1.75699 11.6549L0.342774 10.2407L4.58541 5.99804L0.342773 1.7554L1.75699 0.341187L5.99963 4.58383L10.2423 0.341187L11.6565 1.7554L7.41384 5.99804L11.6565 10.2407L10.2423 11.6549Z" fill="#6D6F71"/>
                                    </svg>
                                </div>
                            </div>
                            <div class="new-item-row">
                                <div class="category-item-elem">
                                    <input placeholder="Добавить код" type="text" v-model="cat.newItem">
                                </div>
                                <div class="category-item-elem" @click="addCategoryItem(cat)">
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M14 7.99805H8V13.998H6V7.99805H0V5.99805H6V-0.00195312H8V5.99805H14V7.99805Z" fill="#6D6F71"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div class="btn default" @click="updateCategory(cat)">
                            <span>Сохранить</span>
                        </div>
                    </div>
                    <div class="category-card">
                        <p class="card-head">Новая категория</p>
                        <input name="header-text" id="header-text" placeholder="Заголовок" v-model="headerValueCategory">
                        <input name="label" id="label" placeholder="Подпись" v-model="textValueCategory">
                        <input name="url" id="url" placeholder="Ссылка" v-model="urlValueCategory">
                        <div class="btn default" @click="addCategory">
                            <span>Добавить</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
    @use '~@/assets/styles/vars' as *;
    .card {
        margin-top: 30px;
        padding: 20px;
        box-sizing: border-box;
        border-radius: 10px;
        background: $light-gray;
    }

    .card-content {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        gap: 20px;
    }

    .text-content {
        display: flex;
        flex-direction: column;
        gap: 5px;
        width: 100%;
    }

    .text-content input {
        width: 100%;
    }

    .images-block {
        width: auto !important;
    }

    h4 {
        font-size: 16px;
        font-weight: 500;
    }

    .header-row {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 10px;
        margin-bottom: 15px;
    }

    .categories-block {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        gap: 5px;
        flex-wrap: wrap;
    }

    .category-card {
        flex-basis: calc(20% - 5px);
        max-width: calc(20% - 5px);
        background: $white;
        border: 1px solid $silver;
        border-radius: 10px;

        padding: 15px 20px;
        box-sizing: border-box;

        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 5px
    }

    .category-card .btn {
        margin-top: 5px;
    }

    .card-head {
        font-size: 14px;
        font-weight: 500;
        margin-bottom: 5px;
    }

    .hr {
        min-height: 1px;
        width: 100%;
    }

    .btn-purple {
        border: 1px solid $purple;
        color: $purple;
        background: none;
    }

    .category-items-block {
        display: flex;
        flex-direction: column;
        gap: 3px;
        width: 100%;
    }

    .category-items {
        width: 100%;
        display: flex;
        flex-direction: row;
        gap: 3px;
        flex-wrap: wrap;
    }

    .category-item-elem {
        display: inline-flex;
        align-items: center;
        gap: 5px;
        background: $silver;
        padding: 7px 9px;
        border-radius: 5px;
        box-sizing: border-box;
        font-size: 12px;
        color: $hard-gray
    }

    .category-item-elem input {
        font-size: 12px !important;
        width: 100%;
        padding: 0;
        border-radius: 0;
        border: none;
        outline: none;
        background: $silver;
    }

    .category-item-elem input:focus {
        outline: none;
    }

    .new-item-row {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        gap: 3px;
    }

    .category-item-elem svg {
        width: 100%;
        height: 100%
    }

    .ticker-text__content {
        display: flex;
        flex-direction: row;
        gap: 10px;
    }
</style>